import { createModalsComponent } from 'modules/campaigns/lib';
import { ConfirmDefaultDisplayPriorityModal } from 'modules/campaigns/lib/modals/ConfirmDefaultDisplayPriorityModal';
import { NoOpComponent } from 'utils/reactHelpers';
import { ModalProps, ModalType, useModalContext } from '../context';
import { AbortCampaignModal } from './AbortCampaignModal';
import { ActivateCampaignModal } from './ActivateCampaignModal';
import { CancelCampaignModal } from './CancelCampaignModal';
import { ChangeCampaignStateModal } from './ChangeCampaignStateModal';
import { ConfirmDisplayEligibilityCampaignModal } from './ConfirmDisplayEligibilityCampaignModal';
import { ConfirmScheduleCampaignModal } from './ConfirmScheduleCampaignModal';
import { DeactivateCampaignModal } from './DeactivateCampaignModal';
import { DisplayEligibilityCampaignModal } from './DisplayEligibilityCampaignModal';
import { InAppRecallModal } from './InAppRecallModal';
import { ScheduleCampaignModal } from './ScheduleCampaignModal';
import { ScheduleUnsavedChangesModal } from './ScheduleUnsavedChangesModal';
import { SendCampaignModal } from './SendCampaignModal';
import { SendTimeExperimentCampaignModal } from './SendTimeExperimentCampaignModal';

const MODAL_COMPONENTS_MAPPER = {
  [ModalType.None]: NoOpComponent,
  [ModalType.AbortCampaignModal]: AbortCampaignModal,
  [ModalType.ActivateCampaignModal]: ActivateCampaignModal,
  [ModalType.CancelCampaignModal]: CancelCampaignModal,
  [ModalType.ChangeCampaignState]: ChangeCampaignStateModal,
  [ModalType.ConfirmDisplayEligibilityCampaign]: ConfirmDisplayEligibilityCampaignModal,
  [ModalType.ConfirmDefaultDisplayPriorityModal]: ConfirmDefaultDisplayPriorityModal,
  [ModalType.ConfirmScheduleCampaign]: ConfirmScheduleCampaignModal,
  [ModalType.DeactivateCampaignModal]: DeactivateCampaignModal,
  [ModalType.DisplayEligibilityCampaign]: DisplayEligibilityCampaignModal,
  [ModalType.InAppRecallModal]: InAppRecallModal,
  [ModalType.ScheduleCampaign]: ScheduleCampaignModal,
  [ModalType.ScheduleUnsavedChangesModal]: ScheduleUnsavedChangesModal,
  [ModalType.SendCampaign]: SendCampaignModal,
  [ModalType.SendTimeExperimentCampaignModal]: SendTimeExperimentCampaignModal,
};

export const Modals = createModalsComponent<ModalType, ModalProps>(
  MODAL_COMPONENTS_MAPPER,
  useModalContext,
);
